module.exports = __webpack_public_path__ + "static/media/background_ia_3.86194ef7.jpeg";